import Image from "components/atoms/Image";
import Link from "components/atoms/Link";
import Player from "components/molecules/player";
import { BASE_URL } from "constants/env";
import { isExternal } from "utils/utils-common";
import React from "react";
import "./index.scss";

interface PromotioncardProps {
  promotion: any;
}

const Promotioncard: React.FC<PromotioncardProps> = ({
  promotion,
}: PromotioncardProps) => {
  return promotion.link &&
    promotion.link.match(/^https:\/\/www.youtube.com/) ? (
    <Player src={promotion.link} ratio={0.5625} fillPlaceholder /> // 225/400
  ) : (
    <Link
      href={`${promotion.link}`}
      isLinkRouter={!isExternal(promotion.link)}
      target={Boolean(isExternal(promotion.link))}
    >
      <div className="m-promotioncard">
        <Image src={promotion.image ? `${BASE_URL}${promotion.image}` : ''} alt={promotion.title} />
      </div>
    </Link>
  );
};

Promotioncard.defaultProps = {};

export default Promotioncard;
